import { Select, Option } from 'element-ui'
import HttpFactory from '@/mixins/http.factory';
//import Multiselect from 'vue-multiselect'
export default {
	name:'configure',
	mixins:[HttpFactory],
	data () {
		return {
			data:null,
			configData:{fieldMapping:[],hdFields:[],devOpsFields:[],devOpsMapList:[],zendeskMapList:[]},
			zendeskInfo: {},
			fieldsMapping: [],
			devOpsTenants: [],
			devOpsTenant:''
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			let _self=this;
			modalClient = ZAFClient.init();
			parentClient=null;
			modalClient.on('send_data_to_modal', async (data) => {
				if (data.ticket.id == _self.$route.params.zdTicketId) {
					parentClient = modalClient.instance(data.parentClientGuid)
					_self.zendeskInfo = data;
					_self.devOpsTenant = _self.zendeskInfo.userInfo.allowMultiTenant ? _self.zendeskInfo.userInfo.defaultTenant : null;
					if (_self.zendeskInfo.userInfo.allowMultiTenant) {
						_self.getTenantsListFn(_self.devOpsTenant);
					} else {
						await _self.getConfigData();
					}
				}
			});
		},
		getTenantsListFn(devOpsTenant){
			let _self = this;
			
			_self.devOpsTenantDataFn(devOpsTenant,function (tenantsResp) {
				_self.devOpsTenants = tenantsResp.data.Data;
				
				devOpsTenant = devOpsTenant ? devOpsTenant : _self.devOpsTenants[0].organizationName;
				_self.getConfigData(devOpsTenant);
			});
		},
		async getConfigData(devOpsTenant){
			let _self=this;
			_self.fn().clearMessage();
			_self.fn().showLoader(true);
			let url =`configData/get`;
			let data={auth:_self.zendeskInfo.credentials,devOpsTenant:devOpsTenant};
			let response=await _self.post(url,data);
			_self.fn().showLoader(false);
			let configData=response.data.Data;
			//exclude System and Microsoft default fields from Custom Fields list
			// also exclude WEF_61C448B651F645D5883FCE6D92119478_Column
			configData.devOpsMapList=configData.devOpsFields.value.filter(d=>d.referenceName 
					&& d.referenceName.indexOf('System.')<0 
					&& d.referenceName.indexOf('Microsoft.')<0
					&& d.referenceName.indexOf('WEF_')!=0);
			configData.zendeskMapList=configData.hdFields.filter(d=>d.removable);//.filter(d=>d.type && d.type.indexOf('custom')>=0);
			
			//only text or strig type
			configData.devOpsMapList=configData.devOpsMapList.filter(d=>d.type=='integer' || d.type=='string' || d.type=='html');
			configData.zendeskMapList=configData.zendeskMapList.filter(d=>d.type=='text' || d.type=='textarea' || d.type=='integer');
			
			_self.configData=configData;
			let fieldsMapping=response.data.Data.fieldsMapping;
			if(!fieldsMapping){
				fieldsMapping={
					hdFieldName:'',
					hdFieldMappingId:'',
					devOpsFieldName:'',
					devOpsFieldMappingId: '',
					hdFieldId_Count: '',
					hdFieldType_Count: '',
					devOpsFieldName_Count: '',
					devOpsFieldType_Count: '',
					hdAllowCustTags: '',
					devOpsAllowCustTags: '',
					devOpsAllowHDLinks:0
				}

				let defaultZdField=configData.hdFields.find(d=>d.title=="Zendesk Ticket #");
				fieldsMapping.hdFieldName=defaultZdField?defaultZdField.id:'';

				let defaultDevField=configData.devOpsFields.value.find(d=>d.name=="Work Item #");
				fieldsMapping.devOpsFieldName=defaultDevField?defaultDevField.referenceName:'';
			}else{
				fieldsMapping.devOpsFieldMappingId = fieldsMapping.devOpsFieldMappingId ? parseInt(fieldsMapping.devOpsFieldMappingId) : fieldsMapping.devOpsFieldMappingId;
				fieldsMapping.hdFieldId_Count=fieldsMapping.hdFieldId_Count?parseInt(fieldsMapping.hdFieldId_Count):fieldsMapping.hdFieldId_Count;
			}
			_self.fieldsMapping=fieldsMapping;
			
		},
		handleFieldType:function(fieldMappingId,type,fieldType_Var){
			let _self=this;
			if(type=='devops'){
				let field=_self.configData.devOpsFields.value.find(d=>d.referenceName==fieldMappingId);
				if(field){
					_self.fieldsMapping[fieldType_Var]=field.type;
				}
			}
			if(type=='zendesk'){
				let field=_self.configData.hdFields.find(d=>d.id==fieldMappingId);
				if(field){
					_self.fieldsMapping[fieldType_Var]=field.type;
				}
			}
		},
		saveConfigDataFn(){
			let _self=this;
			_self.fn().clearMessage();
			let url=`fieldsmapping/saveupdate`;
			_self.handleFieldType(_self.fieldsMapping.hdFieldMappingId,'devops','devOpsFieldType')
			_self.handleFieldType(_self.fieldsMapping.devOpsFieldMappingId, 'zendesk', 'hdFieldType');

			_self.handleFieldType(_self.fieldsMapping.hdFieldId_Count,'zendesk','hdFieldType_Count');
			_self.handleFieldType(_self.fieldsMapping.devOpsFieldName_Count, 'devops', 'devOpsFieldType_Count')
			
			_self.fieldsMapping.devOpsAllowHDLinks = _self.fieldsMapping.devOpsAllowHDLinks ? parseInt(_self.fieldsMapping.devOpsAllowHDLinks) : 0;

			let data=_self.fieldsMapping;
			
			data.auth=_self.zendeskInfo.credentials;
			data.user = _self.zendeskInfo.user;
			if (_self.zendeskInfo.userInfo.allowMultiTenant) data.devOpsTenant = _self.devOpsTenant;
			_self.fn().showLoader(true);
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				//let data=response.data.Data;
				if(response.data.Success){
					let userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`Config data saved Successfully`]}
					_self.userMsg=userMsg;
					console.log(userMsg);
				}
				//_self.sendDataToParent(response.data);
			}).catch(error=>{
				_self.fn().showLoader(false);
				_self.commonErrorMsgDisp(error);
			});
		},
		devOpsTenantDataFn:function(devOpsTenant,successCb,errorCb){
            var _self=this;
            var url = `dev-ops/tenants/${devOpsTenant}`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
        },
		getFieldsmapping(){
			let _self=this;
			let url=`fieldsmapping/get`;
			let data={auth:_self.zendeskInfo.credentials};
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				let fieldsMapping=response.data.Data;
				_self.fieldsMapping=fieldsMapping;
			}).catch(error=>{
				_self.commonErrorMsgDisp(error);
			});
		},
		closeDialog(){
			modalClient.invoke('destroy');
		},
		sendDataToParent(data){
			parentClient.trigger('receive_data_from_modal', data)
      		modalClient.invoke('destroy');

		},
		postServerFn(url,data,successCb,errorCb){
			let _self=this;
			data=data?data:{};
			data.auth=_self.zendeskInfo.credentials;
			_self.post(url,data).then(response=>{
				if(successCb) successCb(response);
			}).catch(error=>{
				if(errorCb) errorCb(error);
			});
		}
	},
	components:{[Select.name]: Select,[Option.name]: Option}
}

